document.addEventListener('DOMContentLoaded', () => {
  const productForm = document.querySelector('.page-content--product .product-single__form');
  
  const checkVariant = (arr) => {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const variantParam = urlSearchParams.get('variant');
      
      if (!variantParam) {
          return false; 
      }
      return Array.from(arr).some(item => item.textContent.trim() === variantParam.trim());
  }
  
  if(productForm){
    const arrForToggleNote = productForm.querySelectorAll('.product__variants-hintShipping .varaint__item-hintShipping');
    const noteShippingEl = productForm.querySelector('.product__variant-note');
    const isShowNoteInit = checkVariant(arrForToggleNote);

    if(isShowNoteInit){
      noteShippingEl.style.display = "block";
    }else{
      noteShippingEl.style.display = "none";
    }

    const variantInputs = productForm.querySelectorAll('.variant-input'); 
    variantInputs.forEach(variantBtn => {
    	variantBtn.addEventListener('click', () =>  {
          console.log('== change variant ==');
           setTimeout(() => {
            const isShowNoteVariant = checkVariant(arrForToggleNote);
             if(isShowNoteVariant){
                noteShippingEl.style.display = "block";
              }else{
                noteShippingEl.style.display = "none";
              }
        	console.log('== check url ==');
           }, 500);
            
        })
    });
    
  }
  console.log('toggle__note__shipping');
})